import { render, staticRenderFns } from "./Trueorfalse.vue?vue&type=template&id=2bbe3984&"
import script from "./Trueorfalse.vue?vue&type=script&lang=js&"
export * from "./Trueorfalse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports